import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/bookingsSagas";
import SectionToggle from "../../../components/sectionToggle/sectionToggle";
import LoadingAnimation from "../../../components/loadingAnimation/loadingAnimation";
import { CustomDateRanges } from "./smartComponents/CustomDateRanges";
import { DatePicker } from "./smartComponents/DatePicker";
import { Dropdown } from "./smartComponents/Dropdown";
import { BookingDate } from "./smartComponents/BookingDate";
import { UpdateButtons } from "./smartComponents/UpdateButtons";
import { LineChart } from "./smartComponents/LineChart";
import { ScoreCards } from "./smartComponents/ScoreCards";
import { BookingTable } from "./smartComponents/BookingTable";
import KBLearnMore from "../../../components/learnMore/KBLearnMore";
import { ILEARN_URLS } from "../../../constants/ilearnUrls";
import "../attendance_common.css.scss";
import { FutureBookings } from "./smartComponents/FutureBookings";

const BookingsModule = (props) => {
  const isLoading = useSelector((state) => state.bookings.isLoading);
  const initialRequest = useSelector((state) => state.bookings.initialRequest);
  const updatesLoading = useSelector((state) => state.bookings.updatesLoading);
  const future_bookings = useSelector((state) => state.bookings.selectedFilters.future_bookings);

  const dispatch = useDispatch();

  useEffect(() => {
    !initialRequest && dispatch(actionCreators.fetchCurrentUser(props));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div>
              {!future_bookings ? (
                <div className="select-box-no-width">
                  <BookingDate />
                </div>
              ) : null}
            </div>
            <div>
              <div className="select-box-no-width">
                <FutureBookings />
              </div>
            </div>
            {!future_bookings ? (
              <div className="select-box-no-width date-range-select-box">
                <p>Date Range</p>
                <CustomDateRanges />
              </div>
            ) : null}

            <div className="date-select-box multi">
              <p>Date</p>
              <DatePicker />
            </div>
          </div>
          <div className="bottom-filter">
            <Dropdown title="Instructor" slice="staff_ids" />
            <Dropdown title="Class Name" slice="class_uids" />
            <Dropdown title="Class Time" slice="class_time" />
            <Dropdown title="Status" slice="status" />
            <Dropdown
              title="Group By"
              slice="group_by"
              isStatic
              includeSelectAll={false}
              enableOnly={false}
            />

            <div>
              <UpdateButtons />
            </div>
          </div>
        </div>
        <ScoreCards />

        <div data-testid="charts-container" className="chart-root">
          {updatesLoading ? (
            <LoadingAnimation text="Updating data..." />
          ) : (
            <>
              <LineChart />
              <BookingTable />
            </>
          )}
        </div>
      </div>
    );
  };

  return (
    <div id="attendance-root" className="bookings-module">
      <SectionToggle
        autoHeight
        title="Bookings"
        isLoading={isLoading}
        content={content()}
        learnMore={
          <KBLearnMore
            title="Bookings"
            description="This report shows all class bookings across your selected date range, grouped by instructor, class name, status, or time. These insights help you understand class demand, evaluate scheduling effectiveness, and identify patterns that drive participation."
            kbUrl={ILEARN_URLS.attendance.bookings}
          />
        }
      />
    </div>
  );
};

export default React.memo(BookingsModule);
